import React from 'react';

const PlantAreaBox = (props) => {
  return (
    <>
      <h2 className="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">
        {props.area.name}
      </h2>
      <p className="leading-relaxed text-base mb-4">{props.area.description}</p>
      <button
        onClick={() => props.showPlants(props.area)}
        className="text-accent-500 inline-flex items-center"
      >
        <svg
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          className="w-4 h-4 ml-2"
          viewBox="0 0 24 24"
        >
          <path d="M5 12h14M12 5l7 7-7 7"></path>
        </svg>
      </button>
    </>
  );
};

export default PlantAreaBox;
